export const ALL_FILE_TYPES = "/file_type/list";
export const ADD_FILE_TYPE = "/file_type/add";
export const UPDATE_FILE_TYPE = "/file_type/update";
export const DELETE_FILE_TYPE = "/file_type/delete";
export const FILE_TYPE_BY_ID = "/file_type/detail";
